import http from "src/services/http";
import store from "src/store";
import * as types from "src/store/types/menus";

export const carregarModulos = () => {
  return new Promise((resolve, reject) => {
    http.get("/api/v2/empresa/menus").then(
      (response) => {
        store.dispatch({
          type: types.MENUS_SET_MODULOS,
          payload: response.data,
        });
      },
      (error) => {
        console.log(error);
      }
    );
  });
};
